var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-section"},[_c('h4',{staticClass:"menu-text"},[_vm._v(_vm._s(_vm.menu.section))]),_c('i',{staticClass:"menu-icon flaticon-more-v2"})])}
var staticRenderFns = []

export { render, staticRenderFns }